import React from "react";
import { useTranslation } from "react-i18next";
import {
  ActionIconContainer,
  AddFormButton,
} from "../../../../shared/components/TableElements";
import { Container, Modal, Row, Col } from "react-bootstrap";
import {
  FormGroupLabel,
  FormItem,
} from "../../../../shared/components/form/FormElements";
import Error from "@/shared/components/form/Error";
import { formInputStyles } from "../../../../shared/constants/styles";

const CreateDocNamePopup = ({
  show,
  onClose,
  onAddDocName,
  docNamePopupErr,
}) => {
  const { t } = useTranslation("common");
  const [docName, setDocName] = React.useState("");

  return (
    <Modal show={show} size="md" centered backdropClassName="custom-backdrop">
      <Modal.Header>
        <h4>{t("add_doc")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row className="mb-2">
            <Col md={12}>
              <FormGroupLabel className="m-0">{t("document")}</FormGroupLabel>
              <FormItem disabled={false}>
                <input
                  type="text"
                  name="docName"
                  value={docName}
                  onChange={(e) => setDocName(e.target.value)}
                  //defaultValue=""
                  placeholder={t("document")}
                  style={formInputStyles}
                  disabled={false}
                />
              </FormItem>
              {docNamePopupErr && <Error error={docNamePopupErr} />}
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <AddFormButton
          id="save-form-button"
          type="button"
          onClick={() => onAddDocName(docName)}
          disabled={!docName.trim()}
        >
          {t("save")}
        </AddFormButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateDocNamePopup;
